export default __webpack_public_path__ + "static/media/deleivery.7aeedae6.png";